import { render, staticRenderFns } from "./NewProcedureDirectoriesDialog.vue?vue&type=template&id=5abf23ac&"
import script from "./NewProcedureDirectoriesDialog.vue?vue&type=script&lang=js&"
export * from "./NewProcedureDirectoriesDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "NewProcedureDirectoriesDialog.vue"
export default component.exports